import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Model from 'antd/lib/modal';
import Row from 'antd/lib/row';
import React, { useEffect, useState, useContext } from 'react';
import { axiosPostCall } from '../api/axiosCall';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../constant/constants';
import { AuthContext } from '../context/AuthProvider';

function SalesPersonModal({
  isOpen,
  companyId,
  currentSalesPerson,
  callback,
  handleSalesPersonModalCloseClick,
}) {
  const [salesPersonName, setSalesPersonName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useContext(AuthContext);

  useEffect(() => {
    if (isOpen) {
      setSalesPersonName(currentSalesPerson || '');
    }
  }, [isOpen, currentSalesPerson]);

  async function updateSalesPerson() {
    try {
      if (!salesPersonName.trim()) {
        message.error('Please enter a sales person name');
        return;
      }

      setIsLoading(true);
      const res = await axiosPostCall({
        apiEndPoint: API_END_POINT.UPDATE_SALES_PERSON,
        header: {
          Authorization: `Bearer ${token}`,
        },
        body: {
          companyId: companyId,
          salesPersonName: salesPersonName.trim(),
        },
      });

      if (res?.hideErrorFromUser) {
        message.success('Sales person updated successfully');
        callback();
        setSalesPersonName('');
        return;
      } else {
        message.error(res?.error?.message);
      }
    } catch (error) {
      console.error(error);
      message.error(SOMETHING_WENT_WRONG);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <Model
        open={isOpen}
        onCancel={handleSalesPersonModalCloseClick}
        closable={false}
        footer={null}
      >
        <div className='flex flex-col space-y-4'>
          <Row className='font-bold text-2xl self-center'>
            Update Sales Person
          </Row>
          <div className='flex flex-col space-y-2'>
            <label className='font-medium'>Sales Person Name:</label>
            <Input
              placeholder='Enter sales person name'
              value={salesPersonName}
              onChange={(e) => setSalesPersonName(e.target.value)}
              onPressEnter={updateSalesPerson}
            />
          </div>
          <div className='flex flex-row justify-around'>
            <Button
              onClick={updateSalesPerson}
              className='w-32 self-center'
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
      </Model>
    </div>
  );
}

export default SalesPersonModal;
